import React from 'react'

export default function Rapoarte() {
    return (
        <div>
            în curând
        </div>
    )
}
